import styled from "@emotion/styled";

export const ContactWrapper = styled.div`
  margin-top: 5rem;
`;

export const Image = styled.img`
  max-width: 200px;
  margin: 0 auto;
  margin-bottom: 5rem;
  @media (min-width: 1000px) {
      max-width: 400px;
      height: 300px;
    }
`;

export const Technologies = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: -2rem;
   
`;

export const Tech = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100px;
  min-width: 100px;
  margin-bottom: 2rem;
  
`;

export const TechImg = styled.img`
  height: 40px;
  width: 40px;
  padding-bottom: 5px;
  @media (min-width: 1000px) {
    width: 70px;
    height: 70px;

    }
`;

export const TechName = styled.div`
  font-size: 14px;
`;
